"use strict";

exports.__esModule = true;
exports.WEIGHT_OPTIONS = exports.TYPE_OPTIONS = exports.SIZE_OPTIONS = exports.ELEMENT_OPTIONS = exports.ALIGN_OPTIONS = void 0;
let TYPE_OPTIONS = exports.TYPE_OPTIONS = /*#__PURE__*/function (TYPE_OPTIONS) {
  TYPE_OPTIONS["PRIMARY"] = "primary";
  TYPE_OPTIONS["SECONDARY"] = "secondary";
  TYPE_OPTIONS["INFO"] = "info";
  TYPE_OPTIONS["SUCCESS"] = "success";
  TYPE_OPTIONS["WARNING"] = "warning";
  TYPE_OPTIONS["CRITICAL"] = "critical";
  TYPE_OPTIONS["WHITE"] = "white";
  return TYPE_OPTIONS;
}({});
let SIZE_OPTIONS = exports.SIZE_OPTIONS = /*#__PURE__*/function (SIZE_OPTIONS) {
  SIZE_OPTIONS["SMALL"] = "small";
  SIZE_OPTIONS["NORMAL"] = "normal";
  SIZE_OPTIONS["LARGE"] = "large";
  SIZE_OPTIONS["EXTRA_LARGE"] = "extraLarge";
  return SIZE_OPTIONS;
}({});
let WEIGHT_OPTIONS = exports.WEIGHT_OPTIONS = /*#__PURE__*/function (WEIGHT_OPTIONS) {
  WEIGHT_OPTIONS["NORMAL"] = "normal";
  WEIGHT_OPTIONS["MEDIUM"] = "medium";
  WEIGHT_OPTIONS["BOLD"] = "bold";
  return WEIGHT_OPTIONS;
}({});
let ALIGN_OPTIONS = exports.ALIGN_OPTIONS = /*#__PURE__*/function (ALIGN_OPTIONS) {
  ALIGN_OPTIONS["START"] = "start";
  ALIGN_OPTIONS["END"] = "end";
  ALIGN_OPTIONS["LEFT"] = "left";
  ALIGN_OPTIONS["CENTER"] = "center";
  ALIGN_OPTIONS["RIGHT"] = "right";
  ALIGN_OPTIONS["JUSTIFY"] = "justify";
  return ALIGN_OPTIONS;
}({});
let ELEMENT_OPTIONS = exports.ELEMENT_OPTIONS = /*#__PURE__*/function (ELEMENT_OPTIONS) {
  ELEMENT_OPTIONS["P"] = "p";
  ELEMENT_OPTIONS["SPAN"] = "span";
  ELEMENT_OPTIONS["DIV"] = "div";
  return ELEMENT_OPTIONS;
}({});